import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getPercent} from '@ey/utils';
import {labels} from '../../../../../util/utils';
import Tile from '../../../../Common/Tile';
import PieChart from '../../../../Common/Charts/PieChart';
import theme, {lightColor, darkColor} from '@ey/styled-theme';
import {dashboardChartColors} from '../../../../../util/uiconstants';

const ReviewNotes = ({reviewnotesData, onGraphicClick, filterKey}) => {
	const dashboardContext = useSelector((store) => store.dashboardContext);
	const numberFormat = useSelector((store) => store.userPreferences.numberFormat);
	const [isFirstLoad, setIsFirstLoad] = useState(true);
	const [chartData, setChartData] = useState([]);

	const isDark = document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark' ? 'dark' : 'light';
	const themeColor = isDark === 'dark' ? darkColor : lightColor;

	let winWidth = window.innerWidth;

	useEffect(() => {
		buildChartData(dashboardContext.engagements);
	}, [reviewnotesData, dashboardContext]);

	const buildChartData = (engagements) => {
		let filteredReviewNotes = [],
			engagementList = engagements || [];

		// filtering the context for dashboard context
		filteredReviewNotes = reviewnotesData.filter(
			(eng) => engagementList.some((item) => item === eng.engId) || (isFirstLoad && _.isEmpty(engagementList))
		);

		// changing first load value to false after first valid load
		if (isFirstLoad && !_.isEmpty(engagementList)) {
			setIsFirstLoad(false);
		}

		const totalNotesCount = _.sum(filteredReviewNotes.map((item) => item.rNAllCalculatedCount)),
			totalReviewNotesOpenCount = _.sum(filteredReviewNotes.map((item) => item.rNO)),
			totalReviewNotesOpenOverdue = _.sum(
				filteredReviewNotes.map((item) => _.sum([item.rNOLowOD, item.rNOMedOD, item.rNOHighOD, item.rNOCritOD]))
			),
			totalReviewNotesCleared = _.sum(
				filteredReviewNotes.map((item) => _.sum([item.rNCLow, item.rNCMed, item.rNCHigh, item.rNCCrit]))
			),
			totalReviewNotesClearedOverdue = 0,
			totalReviewNotesClosed = _.sum(
				filteredReviewNotes.map((item) => _.sum([item.rNCloMed, item.rNCloLow, item.rNCloCrit, item.rNCloHigh]))
			),
			totalReviewNotesClosedOverdue = 0;

		// building the series object for the pie chart
		const displayData = {
			total: totalNotesCount,
			series: [
				{
					name: labels.open,
					y: getPercent(totalReviewNotesOpenCount, totalNotesCount),
					totalCount: totalReviewNotesOpenCount,
					totalOverdue: totalReviewNotesOpenOverdue,
					color: dashboardChartColors.teal[0]
				},
				{
					name: labels.cleared,
					y: getPercent(totalReviewNotesCleared, totalNotesCount),
					totalCount: totalReviewNotesCleared,
					totalOverdue: totalReviewNotesClearedOverdue,
					color: dashboardChartColors.teal[2]
				},
				{
					name: labels.closed,
					y: getPercent(totalReviewNotesClosed, totalNotesCount),
					totalCount: totalReviewNotesClosed,
					totalOverdue: totalReviewNotesClosedOverdue,
					color: dashboardChartColors.teal[3]
				}
			]
		};
		displayData.series = adjustPercentage(displayData.series);
		setChartData(displayData);
	};

	const adjustPercentage = (items) => {
		let totalPercentage = _.sum(items.map((data) => data.y));
		let item = _.maxBy(items, 'y');

		if (isNaN(totalPercentage)) {
			return items;
		}

		item.y = item.y + (100 - totalPercentage);

		return items;
	};

	const pieProps = {
		chartHeight: winWidth <= 1919 ? 243 : 246,
		legendWidth: 180,
		labelCenterOffset: 10,
		data: chartData.series,
		total: chartData.total,
		totalText: labels.totalNotes,
		chartCenter: [180, 80],
		onGraphicClick: (e) => {
			e.preventDefault();
			const serieLabel = e.point.options.name;
			onGraphicClick(serieLabel, filterKey);
		},
		onOverdueClick: (serieLabel) => onGraphicClick(serieLabel, filterKey)
	};

	const tileProps = {
		title: labels.reviewNotesByStatusTitle,
		subTitle: labels.byStatus,
		isEmpty: chartData.total === 0,
		emptyTitle: labels.thereIsNoDataToDisplay,
		emptySubtitle: labels.selectadditionalEntitiesToContinue
	};

	return (
		<Tile {...tileProps}>
			<PieChart {...pieProps} />
		</Tile>
	);
};

export default ReviewNotes;
